module.exports = __webpack_public_path__ + "static/img/customcomm.675d9916.svg";